import React from 'react'

const SystemSettings = () => {
  return (
    <div>
      <p>bbbjkjkjnjk</p>
    </div>
  )
}

export default SystemSettings
